import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";
import { numberComparatorMax2, numberFilterParams, createNumberFormatter } from "@icarius-table/number";

export default () => [
    {
        pages: [paths.collaboratorSkillsRanking],
        config:
        {
            headerName: getLocalizedString("code"),
            field: "userCode",
            filter: "agTextColumnFilter",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
        }
    },
    {
        pages: [paths.collaboratorSkillsRanking],
        config:
        {
            headerName: getLocalizedString("nameAndSurname"),
            field: "userName",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.collaboratorSkillsRanking],
        config: {
            headerName: getLocalizedString("position"),
            field: "position",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.collaboratorSkillsRanking],
        config: {
            headerName: getLocalizedString("skill"),
            field: "skill",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.collaboratorSkillsRanking],
        config: {
            headerName: getLocalizedString("requiredLevel"),
            field: "requiredLevel",
            filter: "agSetColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.collaboratorSkillsRanking],
        config: {
            headerName: getLocalizedString("realLevel"),
            field: "realLevel",
            filter: "agSetColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.collaboratorSkillsRanking],
        config: {
            headerName: getLocalizedString("gap"),
            field: "gap",
            filter: "agSetColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
            cellRenderer: "GapRenderer",
        }
    },
    {
        pages: [paths.collaboratorSkillsRanking],
        config: {
            headerName: getLocalizedString("fulfillment"),
            field: "fulfillment",
            cellRenderer: "ProgressRenderer",
            filter: "ProgressFilter",
            cellClass: "percentageValue",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.collaboratorSkillsRanking],
        config: {
            headerName: getLocalizedString("result"),
            field: "result",
            filter: "agSetColumnFilter",
            cellRenderer: "ResultRenderer",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.collaboratorSkillsRanking],
        config: {
            headerName: getLocalizedString("indicator"),
            field: "indicator",
            filter: "agSetColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
            cellRenderer: "IndicatorRenderer"
        }
    },
    {
        pages: [paths.collaboratorSkillsRanking],
        config: {
            headerName: getLocalizedString("globalRanking"),
            field: "globalRanking",
            cellRenderer: "ProgressRenderer",
            filter: "ProgressFilter",
            cellClass: "percentageValue",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.collaboratorSkillsRankingSuggestedSkills],
        config:
        {
            headerName: getLocalizedString("code"),
            field: "userCode",
            filter: "agTextColumnFilter",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
        }
    },
    {
        pages: [paths.collaboratorSkillsRankingSuggestedSkills],
        config: {
            headerName: getLocalizedString("nameAndSurname"),
            field: "userName",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.collaboratorSkillsRankingSuggestedSkills],
        config: {
            headerName: getLocalizedString("position"),
            field: "position",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.collaboratorSkillsRankingSuggestedSkills],
        config: {
            headerName: getLocalizedString("skill"),
            field: "skills",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.collaboratorSkillsRankingSuggestedSkills],
        config: {
            headerName: getLocalizedString("suggestedCourses"),
            field: "suggestedSkill",
            filter: "agSetColumnFilter",
        }
    },
]